import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-w-[760px]" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpellingTestResult = _resolveComponent("SpellingTestResult")!
  const _component_GuestFinalScreen = _resolveComponent("GuestFinalScreen")!
  const _component_StudentFinalScreen = _resolveComponent("StudentFinalScreen")!

  return (_ctx.resultScreenVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tw-text-main1 tw-text-sm",
        style: _normalizeStyle(_ctx.resultStyle)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SpellingTestResult, {
            student: _ctx.$currentUser.value,
            "guest-name": _ctx.guestName,
            "result-data": _ctx.resultData,
            "test-result-info": _ctx.resultInfo
          }, null, 8, ["student", "guest-name", "result-data", "test-result-info"])
        ])
      ], 4))
    : (_ctx.isGuest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_GuestFinalScreen, {
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            onNameSet: _cache[1] || (_cache[1] = ($event: any) => {
        _ctx.guestName = $event;
        _ctx.resultScreenVisible = true;
      })
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_StudentFinalScreen, {
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
            onShowresults: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resultScreenVisible = true))
          })
        ]))
}